import React from 'react';
import styled from 'styled-components';

import { Box } from 'grommet';
import Paragraph from 'app/components/Paragraph';

const Image = styled.img`
  max-width: 150px;
  height: auto;
`;

const ImageFrame = styled.div`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 18px;
  margin-bottom: 18px;
  margin: 0;
  padding: 0;
`;

function Thumbnail({ path, content }) {
  return (
    <Box
      direction="row"
      flex="grow"
      gap="small"
      margin={{ top: 'small', bottom: 'small' }}
    >
      <ImageFrame aria-label="thumbnail object">
        <Image
          src={require('../../../content' + content.source)}
          alt={content.caption}
        />
      </ImageFrame>
      <Paragraph margin="none">{content.text}</Paragraph>
    </Box>
  );
}

export default Thumbnail;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Thumbnail.js